export default [
    {
        name: 'interactive',
        type: 'gltfModel',
        path: './assets/vendor/Interactive.glb'
    }
]